import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  formatDateFromEpoch,
  formatDateTimeRangeFromServer,
  formatUnixTime,
  getSingleDateIfEqual,
  serverFormatToDateString,
  toSingleDateStringIfEqual,
} from "../../../system";
import activitySpotIcon from "../../../assets/images/icon/activity_spot_icon.svg";
import activityCalendarIcon from "../../../assets/images/icon/activity_calendar_icon.svg";
import activityTimeIcon from "../../../assets/images/icon/calender_time_icon.svg";
import ServerFormatToDate from "../FormatDate/ServerFormatToDate";

import {
  DateFormatType,
  Directions,
  timezoneConstants,
  translationConstants,
} from "../../../constants";
import logoPlaceholder from "../../../assets/images/logo/activityLogoPlaceholder.png";
const ActivityCard = ({ activity, setActivityData, setIsViewDetail }) => {
  const { t } = useTranslation();

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const handleViewDetailClick = () => {
    setActivityData(activity);
    setIsViewDetail(true);
  };

  const isMobile = useSelector((state) => {
    return state.systemReducer.isMobile;
  });

  return (
    <>
      <div className="row w-100 p-0">
        <div className="col-md-12 p-0">
          <div
            className="activity-card my-1 cast-shadow-on-hover"
            onClick={handleViewDetailClick}
          >
            <div className="row m-0 gap-3 gap-md-0">
              <div className="col-md-1 d-none d-md-block d-flex justify-content-md-center align-items-md-center px-3 text-md-center">
                <span className="activity-date" dir={Directions.ltr}>
                  <ServerFormatToDate
                    dateString={activity?.centerActivityInfo?.startDateString}
                  />
                </span>
              </div>
              <div className="col-md-9  activity-card-content-wrapper">
                <div className="row">
                  <div className="col-5 col-md-4 col-lg-2 d-lg-flex gap-3 justify-content-center">
                    <div
                      className={`activity-card-image-wrapper ${
                        isMobile ? "w-100" : "h-100px"
                      }`}
                    >
                      <img
                        src={
                          activity?.logo?.link
                            ? activity?.logo?.link
                            : logoPlaceholder
                        }
                        alt="activity"
                      />
                    </div>
                  </div>
                  <div className="col-7 col-md-5 col-lg-7 px-3 px-md-1 d-flex flex-column justify-content-between">
                    <div className="d-flex flex-column justify-content-between h-100 gap-2">
                      <span className="activity-card-heading">
                        {direction === Directions.rtl &&
                        activity?.centerActivityInfo?.arabicName
                          ? `${activity?.centerActivityInfo?.arabicName}`
                          : `${activity?.centerActivityInfo?.name}`}
                      </span>
                      <div>
                        <div className="contact-information-card pt-md-2 pt-0">
                          <img
                            alt=""
                            name="activitySpot"
                            src={activitySpotIcon}
                          />
                          <span>
                            {direction === Directions.rtl &&
                            activity?.spotArabicName
                              ? `${activity?.spotArabicName}`
                              : `${activity?.spotName}`}
                          </span>
                        </div>
                        <div className="d-flex align-items-center flex-wrap gap-3">
                          <div className="contact-information-card pt-2">
                            <img
                              alt=""
                              name="activityDate"
                              src={activityCalendarIcon}
                            />
                            <span>
                              {toSingleDateStringIfEqual(
                                activity?.centerActivityInfo?.startDateString,
                                activity?.centerActivityInfo?.endDateString
                              )}
                            </span>
                          </div>
                          <div className="contact-information-card pt-md-2 pt-0 me-3">
                            <img
                              alt=""
                              name="activitySpot"
                              src={activityTimeIcon}
                            />
                            <span>
                              {formatDateTimeRangeFromServer(
                                activity?.centerActivityInfo?.startDateString,
                                activity?.centerActivityInfo?.endDateString,
                                timezoneConstants.hourMinuteFormat
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivityCard;
